import React, { useEffect, useState } from "react";
import whatsapp from "../../Images/Group 534.png";
import arrow2 from "../../Images/Vector (11).png";
import heart from "../../Images/Vector (10).png";
import redHeart from "../../Images/red-heart.png";
import plus from "../../Images/Vector@2x.png";
import HomeService from "../../Services/HomeService";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import PropertyCard from "./PropertyCard";

const PropertyGrid = ({ propertyData, loading, showFav, activeData }) => {
  const [properties, setProperties] = useState([]);
  const [userId, setUserId] = useState("");
  const location = useLocation();
  const { filteredProperty } = location.state || [];
  const [isClicked, setIsClicked] = useState(false);
  const [remarks, setRemarks] = useState({});

  // console.log("TREE20W",propertyData);


  useEffect(() => {
    // if (propertyData) {
    setProperties(propertyData);
    // }
  }, [propertyData]);

  const [favPropertyId, setFavPropertyId] = useState("")

  const handleClick = async (propertyId) => {
    console.log("propertyId", propertyId);
    setFavPropertyId(propertyId)
    try {
      const data = { userId, propertyId };
      const res = await HomeService.addToWishList(data);
      console.log("JHG35", res);

      console.log("wishlist adding status", res);

      if (res?.status) {
        setIsClicked(!isClicked);
      } else {
        console.error("Failed to add property to wishlist:", res?.message);
      }
    } catch (error) {
      console.error("Error adding property to wishlist:", error);
    }
  };

  const fetchLoginProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      setUserId(response.data?._id || "");
    } catch (error) {
      console.error("Error fetching login profile:", error);
    }
  };

  const fetchAllProperty = async () => {
    try {
      if (filteredProperty) {
        setProperties(filteredProperty);
      } else {
        const response = await HomeService.getProperties({ userId });
        setProperties(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching properties:", error);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
  }, []);

  useEffect(() => {
    if (userId || filteredProperty) {
      // fetchAllProperty();
      console.log("KJH78", propertyData, favPropertyId);


      // setProperties(propertyData);
    }
  }, [userId, filteredProperty, isClicked]);

  useEffect(() => {
    // fetchAllProperty();
    console.log("KJH89", properties, propertyData, favPropertyId);
    if (properties.length > 0) {
      setProperties(prevProperties =>
        prevProperties.map(property =>
          property._id === favPropertyId
            ? { ...property, isFavorite: !property.isFavorite }
            : property
        )
      );
    }
  }, [isClicked]);

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;
  const totalPages = Math.ceil(properties?.length / itemsPerPage);

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = properties?.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleChangeRemarks = (id, value) => {
    setRemarks((prevData) => ({
      ...prevData,
      [id]: value, // Each key is the employee's ID
    }));
    console.log("remarks", remarks);
  };

  // const handleRemarksSubmit = async () => {
  //   console.log("data", remarks);
  //   try {
  //     const res = await HomeService.addRemarks({
  //       propertyId: Object.keys(remarks)[0],
  //       remarks: Object.values(remarks)[0],
  //     });
  //     if (res?.status) {
  //       toast.success(res.message);
  //     } else {
  //       toast.error("Error while adding Feedback!");
  //     }
  //   } catch (error) {
  //     console.error("Error While adding Remarks!");
  //   }
  //   setRemarks("");
  // };
  console.log(currentItems);
  return (
    <>
      {loading && <><div className="property_grid_div">Loading properties...</div></>}
      <div className="property_grid_div">
        {properties?.length === 0 ? (
          <div className="no_data_message">No Property found</div>
        ) : (
          currentItems?.map((property, index) => (
            <PropertyCard
              property={property}
              index={index}
              handleClick={handleClick}
              showFav={showFav}
              activeData={activeData}
            // handleRemarksSubmit={handleRemarksSubmit}
            />

            // ---------------------- I have made a new Component To solve the remark post function -----------------------

            // <div
            //   className="property_grid_one property_grid_new_class"
            //   key={property._id || index}
            // >
            //   <div className="propety_grid_img property_grid_img_new">
            //     <img
            //       className="propety_grid_img_display propety_grid_img_display_new"
            //       src={property.city?.image || "/fallback-image.png"}
            //       alt="Property"
            //     />
            //     <div
            //       className="heart_div_2"
            //       onClick={() => handleClick(property._id)}
            //     >
            //       <img
            //         src={property?.isFavorite ? redHeart : heart}
            //         alt="Favorite"
            //       />
            //     </div>
            //   </div>

            //   <div className="property_grid_data property_grid_data_new">
            //     <div className="property_grid_content">
            //       <div className="property_data">
            //         <div className="property_para_div">
            //           <p className="property_data_para">Locality:</p>
            //           <p className="property_data_para2">
            //             {property.locality.name || "N/A"}
            //           </p>
            //         </div>
            //         <div className="property_para_div">
            //           <p className="property_data_para">BHK:</p>
            //           <p className="property_data_para2">
            //             {property.bhk || "N/A"}
            //           </p>
            //         </div>
            //         <div className="property_para_div">
            //           <p className="property_data_para">Contact:</p>
            //           <p className="property_data_para2">
            //             {property.phoneNo || "N/A"}
            //           </p>
            //         </div>
            //       </div>

            //       <div className="property_data">
            //         <div className="property_para_div">
            //           <p className="property_data_para">Address:</p>
            //           <p className="property_data_para2">
            //             {property.address || "N/A"}
            //           </p>
            //         </div>
            //         <div className="property_para_div">
            //           <p className="property_data_para">Property Type:</p>
            //           <p className="property_data_para2">
            //             {property.propertytype?.propertyType || "N/A"}
            //           </p>
            //         </div>
            //       </div>
            //     </div>

            //     <div className="remark_button_wrapper_div">
            //       <p>Remark</p>

            //       <input
            //         value={remarks[property._id] || ""}
            //         onChange={(e) => {
            //           //if (remarks) {
            //           handleChangeRemarks(property._id, e.target.value);
            //           // } else {
            //           //   toast.error(
            //           //     "You can't write another remarks while writting other remarks1"
            //           //   );
            //           // }
            //         }}
            //         type="text"
            //         placeholder="Type something for your own use..."
            //       />
            //       <div className="submit_btn_icon_wrapper">
            //         <button
            //           onClick={() => {
            //             handleRemarksSubmit();
            //           }}
            //         >
            //           Submit
            //         </button>
            //         <div className="d-flex" style={{ columnGap: "12px" }}>
            //           <div
            //             className="icon_1_div"
            //             onClick={() => handleClick(property._id)}
            //           >
            //             <img
            //               src={property?.isFavorite ? redHeart : heart}
            //               alt="Favorite"
            //             />
            //           </div>
            //           <div className="icon_1_div">
            //             <img src={whatsapp} alt="WhatsApp" />
            //           </div>
            //           <div className="icon_1_div">
            //             <img src={arrow2} alt="Share" />
            //           </div>
            //         </div>
            //       </div>
            //     </div>
            //   </div>

            //   {/* <div className="plus_div_icon">
            //     <img src={plus} alt="Add" />
            //   </div> */}
            // </div>
          ))
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <nav className="d-flex justify-content-end pagination">
            <ul className="pagination">
              {/* Previous Button */}
              <li
                className={`page-item text-dark ${currentPage === 1 ? "disabled" : ""
                  }`}
                style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                <a className="page-link text-dark">Previous</a>
              </li>

              {/* Dynamic Page Numbers */}
              {Array.from({ length: totalPages }, (_, i) => (
                <li
                  key={i}
                  className={`page-item text-dark ${currentPage === i + 1 ? "active" : ""
                    }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => handlePageChange(i + 1)}
                >
                  <a className="page-link text-dark">{i + 1}</a>
                </li>
              ))}

              {/* Next Button */}
              <li
                className={`page-item text-dark ${currentPage === totalPages ? "disabled" : ""
                  }`}
                style={{
                  cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                }}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                <a className="page-link text-dark">Next</a>
              </li>
            </ul>
          </nav>
        )}
      </div>
    </>
  );
};

export default PropertyGrid;
